import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchModule, type SpeakersEnvelope, type ModuleFilters } from '../api/events';

/**
 * Stable query key for the Events → Speakers module envelope. Exported
 * so sibling code (e.g. an invalidator after an ingest) can refer to
 * the same key without re-deriving it.
 */
export function eventsSpeakersKey(filters?: ModuleFilters) {
  return ['events', 'speakers', filters ?? {}] as const;
}

/**
 * Fetch the Events → Speakers envelope (the SpeakerByFormat matrix +
 * freshness/honesty metadata).
 *
 * Returns the full envelope so consumers can render `<Freshness/>`,
 * `<Denominator/>`, and `<AnomalyChip/>` alongside the matrix.
 */
export function useEventsSpeakers(
  filters?: ModuleFilters,
): UseQueryResult<SpeakersEnvelope, Error> {
  return useQuery({
    queryKey: eventsSpeakersKey(filters),
    queryFn: ({ signal }) => fetchModule('speakers', filters, { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
